<template>
    <!--콘텐츠 영역-->
    <div class="mainbusiness_wrap">
        <div id="sub_contents" class="mainbusiness schorlarship">
            <div class="tit">
                    <div>SONGWON FOUNDATION</div>
                    <h3>
                        송원문화재단은 재능 있는 학생이 경제적인 어려움을 겪지 않고 학업에 전념할 수 있는 여건을 조성하여,<br>
                        자신의 꿈을 향해 나아갈 수 있도록 돕고자합니다.
                    </h3>
                </div>
                <div class="cont_wrap" style="height:1300px">
                    <div class="cont">
                        <div><img :src="require('./../../assets/img/sub/01/scholarship1.png')" /></div>
                        <div>
                            <h3>에스모드 서울재단 장학생 증서수여식</h3>
                            <span>3명의 송원장학생 선발</span>
                            <p>
                                송원문화재단과 에스모드서울재단의 업무협약을 통해 송원장학생을 선발하여 패션디자인 장학금을 지정기탁합니다.
                                이를 통해 학생의 재능 발전과 꿈을 향해 전진할 수 있도록 사업을 추진하고 있습니다.
                            </p>
                            <a href="/notice/detail?id=64ae69bbdfe7c83faae0e721&type=1">자세히 보기 +</a>
                        </div>
                    </div>
                    <div class="cont" style="top:400px">
                        <div><img :src="require('./../../assets/img/sub/01/scholarship2.png')" /></div>
                        <div>
                            <h3>에스모드 서울재단 장학생 증서수여식</h3>
                            <span>3명의 송원장학생 선발</span>
                            <a href="/notice/detail?id=64ae69bbdfe7c83faae0e721&type=1">자세히 보기 +</a>
                        </div>
                    </div>
                    <div class="cont">
                        <div><img :src="require('./../../assets/img/sub/01/scholarship3.png')" /></div>
                        <div>
                            <h3>에스모드 서울재단 송원장학생 소식</h3>
                            <span>4명의 송원장학생 Dolce&Gabbana for ESMOD Seoul 참가</span>
                            <a href="/notice/detail?id=64ae67f8dfe7c83faae0e6f1&type=1">자세히 보기 +</a>
                        </div>
                    </div>
                    <div class="cont">
                        <div><img :src="require('./../../assets/img/sub/01/scholarship4.png')" /></div>
                        <div>
                            <h3>에스모드 서울재단 송원장학생 소식</h3>
                            <span>최성우 송원장학생 돌체앤가바나 6개월 인턴 선정</span>
                            <a href="/notice/detail?id=64ae67f8dfe7c83faae0e6f1&type=1" >자세히 보기  +</a>
                        </div>
                    </div>
                    <!--
                    <div class="cont">
                        <div>
                            <h3>캔파운데이션</h3>
                            <span>소외계층을 대상으로 찾아가는 문화예술창작 수업을 진행하고 있습니다.</span>
                        </div>
                    </div>
                    <div class="cont" style="top:1650px">
                        <div>
                            <h3>아름지기</h3>
                            <span>전통문화연구교육사업으로 전통문화의 계승발전을 위한 연구· 교육사업을 추진하고 있습니다.</span>
                        </div>
                    </div>
                    <div class="cont" style="top:1800px;right:0;">
                        <div>
                            <h3>현대미술관회</h3>
                            <span>국립현대미술관의 사회교육을 대행하는 교육프로그램인 현대미술아카데미를 운영하고 있습니다.</span>
                        </div>
                    </div>
                    <div class="cont" style="top:2000px;">
                        <div>
                            <h3>한국메세나협회</h3>
                            <span>조사학술연구사업을 통해 기업의 예술, 사회발전을 위한 학술포럼을 개최합니다.</span>
                        </div>
                    </div>
                -->
                </div>
            </div>
            <div class="process schorlarship_list">
                <div class="mainbusiness">
                        <div>
                            <h3>캔파운데이션</h3>
                            <p>
                                소외계층을 대상으로 찾아가는 문화예술창작 수업을 진행하고 있습니다.
                            </p>
                        </div>
                        <div>
                            <h3>아름지기</h3>
                            <p>
                                전통문화연구교육사업으로 전통문화의 계승발전을 위한 연구· 교육사업을 추진하고 있습니다.
                            </p>
                        </div>
                </div>
                <div class="mainbusiness">
                        <div>
                            <h3>현대미술관회</h3>
                            <p>
                                국립현대미술관의 사회교육을 대행하는 교육프로그램인 현대미술아카데미를 운영하고 있습니다.
                            </p>
                        </div>
                        <div>
                            <h3>한국메세나협회</h3>
                            <p>
                                조사학술연구사업을 통해 기업의 예술, 사회발전을 위한 학술포럼을 개최합니다.
                            </p>
                        </div>
                </div>
            </div>
    </div>
</template>

<script>

export default {
    data: () => ({
        message: "Brochure.vue"
    }),
    methods: {},
    computed: {
        IS_MOBILE() {
            return this.$root.$data.isMobileMode;
        }
    },
    destroyed() { },
    created() {
        console.log("created - " + this.message);
    }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/sub01/ScholarshipSelection.vue